import Head from 'next/head';

import { VerificationProvider } from '../contexts/VerificationContext';

import { sitemapApi } from '../api/sitemapAPI';

import { DefaultLayout } from '../components/Layouts';
import { SitemapPage } from '../components/Sitemap/SitemapPage';
import { ErrorPage } from '../components/ErrorPages/ErrorPage';

import type { Section } from '../components/Sitemap/SitemapPage.typed';
import getConfig from 'next/config';
import { PAGE } from '../helpers/pages';
import { logger } from '@dist-marketplace-frontend/services';

interface SiteMapProps {
  sections?: Section[];
}

function Sitemap(props: SiteMapProps) {
  const { sections } = props;
  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();

  const TITLE_COPY = "DoneDeal.ie - Ireland's biggest classifieds site";

  if (sections) {
    return (
      <VerificationProvider>
        <Head>
          <title>{TITLE_COPY}</title>
        </Head>
        <DefaultLayout useGenericLogoInHeader>
          <SitemapPage sections={sections} />
        </DefaultLayout>
      </VerificationProvider>
    );
  } else {
    return <ErrorPage disableGtmLog cdnUrl={CDN_STATIC_ASSETS} />;
  }
}

/**
 * TODO: Consider using getStaticProps/ISR instead of getServerSideProps here
 */
export const getServerSideProps = async () => {
  try {
    const {
      data: { sections },
    } = await sitemapApi.getSections();

    return {
      props: {
        sections,
      },
    };
  } catch (error) {
    logger.error({
      route: PAGE.SITEMAP,
      error,
      message: 'Error retrieving sections',
    });
    return {
      props: {},
    };
  }
};

export default Sitemap;
